import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Sidebar from '../../components/Sidebar/Sidebar'
import "./UserDashboard.css"
import { useNavigate, useParams } from 'react-router-dom';
import { Howl } from 'howler';
import { buildApiUrl } from '../../config/api.config';

const clickButton = new Howl({ src: ['/sounds/click.mp3'] });

const UserDashBoard = () => {
    const { userId } = useParams();
    const navigate = useNavigate(); // hook for navigation

    const [userName, setUserName] = useState('')
    const fetchUserDetails = async () => {
        try {
          const response = await fetch(buildApiUrl(`users/admin/getuser/${userId}`), {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'auth-token': localStorage.getItem('token'),
            },
          });
    
          const data = await response.json();
          if (response.ok) {
            setUserName(data);
          } else {
            toast.error("Error fetching user details");
          }
        } catch (error) {
          toast.error("An error occurred while fetching user details");
        }
      };

        useEffect(() => {
          fetchUserDetails();
        }, [userId]);

        const handleReviewsClick = () => {
            clickButton.play();
            navigate(`/admin/users/reviews/${userId}`); // Navigate to the reviews page
        };
        const handleInvoiceClick = () => {
          clickButton.play();
          navigate(`/admin/users/invoice/${userId}`); // Navigate to the invoice page
      };
  return (
    <div style={{ display: "flex" }}>
      <Sidebar />
      <div className="user-dash">
        <div className="user-dash-form flex-col">
          <h1 className="header">{userName.name}</h1>
          <div className='all-button'>
            <button type="button" className='review-btn' onClick={handleReviewsClick}>Reviews </button>
            <button type="button" className='review-btn' onClick={handleInvoiceClick}>Invoice </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDashBoard;
